import React from "react"
import {containsEmailAddress} from "../../../../utils/stringContainsPIIData"

import {
    PriceParentWrapper,
    ProductDetailItem,
    ProductDetails,
    StatusWrapper,
    Title,
    SearchDescription,
    Price,
    SizeQuantity,
    SizeQuantityText,
    SaleLabel,
} from "./component"

export type ClubMiniShoppingBagDescriptionProps = {
    ProductName: string
    TPSearchDescription: string
    Description: string
    SizeDescription: string
    Quantity: string
    StockStatus: string
    StockMessage: string
    ciStoreName: string
    PriceFormatted: string
    text: any
    IsDiscount: boolean
    saleName: string
    showItemDescription: boolean
    showProductName: boolean
}

export const ClubMiniShoppingBagDescription = ({
    ProductName,
    TPSearchDescription,
    Description,
    IsDiscount,
    PriceFormatted,
    SizeDescription,
    Quantity,
    StockMessage,
    StockStatus,
    ciStoreName,
    text,
    saleName,
    showItemDescription,
    showProductName,
}: ClubMiniShoppingBagDescriptionProps) => {
    const {sizeText, qtyText, price} = text

    return (
        <ProductDetails>
            <ProductDetailItem>
                <div>
                    {ProductName && showProductName && (
                        <Title data-testid="header-mini-shopping-bag-item-name">
                            <span>{ProductName}</span>
                        </Title>
                    )}
                    {showItemDescription && (
                        <SearchDescription data-testid="header-mini-shopping-bag-item-description">
                            {TPSearchDescription || Description}
                        </SearchDescription>
                    )}
                    <SizeQuantity>
                        <SizeQuantityText className="block">
                            {sizeText} {SizeDescription}
                        </SizeQuantityText>
                        <SizeQuantityText className="block mt-5px">
                            {qtyText} {Quantity}
                        </SizeQuantityText>
                    </SizeQuantity>
                </div>
                <PriceParentWrapper>
                    <Price>{PriceFormatted}</Price>
                    {IsDiscount && (
                        <SaleLabel data-testid="header-mini-shopping-bag-item-sale-price">
                            {`${saleName} ${price}`}
                        </SaleLabel>
                    )}
                </PriceParentWrapper>
            </ProductDetailItem>

            <StatusWrapper
                status={StockStatus}
                data-testid="header-mini-shopping-bag-item-status"
                data-dtrum-replay-mask={containsEmailAddress(StockMessage) ? "" : null}
            >{`${StockMessage} ${ciStoreName}`}</StatusWrapper>
        </ProductDetails>
    )
}

export default ClubMiniShoppingBagDescription
